import { QueryClient } from '@tanstack/react-query';

export const QUERY_CLIENT = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,
            refetchOnWindowFocus: false,
        },
    },
});
